import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { prepareEntityUrl } from 'utils/helpers/url';
import styles from './styles.module.scss';

const StyledContentRecommendation = ({ entities, mode }) => {
	if (mode === 'list' && entities) {
		const renderListItem = (item) => {
			const { entity } = item;
			const itemUrl = prepareEntityUrl(entity);

			return (
				<li className={styles.StyledContentRecommendation_Item} key={itemUrl}>
					<a href={itemUrl} target="_blank">
						{entity.title}
					</a>
				</li>
			);
		};

		return (
			<div className={styles.StyledContentRecommendation}>
				<div className={styles.StyledContentRecommendation_Head}>
					<div className={styles.StyledContentRecommendation_WrapIcon}>
						<Icon
							icon="recommendation"
							className={styles.StyledContentRecommendation_Icon}
						/>
					</div>
					Читайте также:
				</div>
				<ul className={styles.StyledContentRecommendation_List}>
					{entities.map((item) => renderListItem(item))}
				</ul>
			</div>
		);
	}

	return null;
};

StyledContentRecommendation.propTypes = {
	entities: PropTypes.arrayOf(
		PropTypes.shape({
			entityType: PropTypes.string,
			entity: PropTypes.shape({ title: PropTypes.string })
		})
	),
	mode: PropTypes.oneOf(['list', 'slider'])
};

export default StyledContentRecommendation;
